import { DateTime } from "luxon";

export default {
  methods: {
    convertToDefaultTimezone(dateTimeStr, time_zone = "UTC") {
      if (dateTimeStr === "-") return "-";
      const storageTimezone = localStorage.getItem("time_zone");
      // get default timezone
      const defaultTimezone =
        storageTimezone && storageTimezone.includes("/")
          ? storageTimezone
          : time_zone;
      // convert by luxon
      const dt = DateTime.fromFormat(dateTimeStr, "yyyy-MM-dd HH:mm:ss", {
        zone: "UTC",
      }).setZone(defaultTimezone);
      return dt.toFormat("yyyy-MM-dd HH:mm:ss");
    },
  },
};
